import { useState } from "react";
import DatePicker from "react-datepicker";
import { Box, Flex, Text } from "@chakra-ui/react";
import styles from "../../../styles/Home.module.css";
import "react-datepicker/dist/react-datepicker.css";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { FormTitle } from "../form.title";

export const DatepickerInput = ({
  name,
  title,
  initialDate,
  required = false,
  onChange,
}: Props) => {
  const [date, setDate] = useState(initialDate ?? new Date());

  return (
    <Box w="100%">
      <FormTitle required mb="4px">{title}</FormTitle>
      <Flex
        flexDir="row"
        gap="4px"
        border="1px solid lightGray"
        borderRadius="6px"
        p="8px 12px"
        w="100%"
      >
        <CalendarMonthOutlinedIcon style={{ color: "#457662" }} />
        <DatePicker
          wrapperClassName={styles.datepicker}
          dateFormat="dd/MM/yyyy"
          selected={date}
          onChange={(date) => {
            setDate(date);
            onChange({ target: { name, value: date } });
          }}
        />
      </Flex>
    </Box>
  );
};

interface Props {
  name: string;
  title?: string;
  initialDate?: Date | string;
  required?: boolean;
  onChange: ({ target: { name, value } }) => void;
}
